// components/LocationDetails.js
import React from 'react';
import { Autocomplete } from '@react-google-maps/api';

const LocationDetails = ({
    autocompleteRef,
    formData,
    handlePlaceChanged,
    handleInputChange,
    errors
}) => {

    return (
        <>
            <div className="mb-3 col-12">
                <label className="form-label">Search location <span className="text-danger">*</span></label>
                <Autocomplete
                    onLoad={(ref) => {
                        if (autocompleteRef && autocompleteRef.current !== undefined) {
                            autocompleteRef.current = ref;
                        }
                    }}
                    onPlaceChanged={handlePlaceChanged}
                >
                    <input
                        type="text"
                        className={`form-control ${errors?.location ? 'is-invalid' : ''}`}
                        placeholder="Search location"
                    />
                </Autocomplete>
                {errors?.location && <div className="text-danger small mt-1">{errors.location}</div>}
            </div>
            <div className="mb-3 col-12">
                <label className="form-label">Full Address</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={formData.address}
                    onChange={(e) => handleInputChange('address', e.target.value)}
                />
            </div>
            <div className="mb-3 col-md-6">
                <label className="form-label">City</label>
                <input
                    type="text"
                    className="form-control"
                    value={formData.city}
                    onChange={(e) => handleInputChange('city', e.target.value)}
                />
            </div>
            <div className="mb-3 col-md-6">
                <label className="form-label">State</label>
                <input
                    type="text"
                    className="form-control"
                    value={formData.state}
                    onChange={(e) => handleInputChange('state', e.target.value)}
                />
            </div>
            <div className="mb-3 col-md-6">
                <label className="form-label">Pincode</label>
                <input
                    type="text"
                    className="form-control"
                    value={formData.pincode}
                    onChange={(e) => handleInputChange('pincode', e.target.value)}
                />
            </div>
            <div className="mb-3 col-md-6">
                <label className="form-label">Latitude / Longitude</label>
                <input
                    type="text"
                    className="form-control"
                    value={`${formData.latitude}, ${formData.longitude}`}
                    readOnly
                />
            </div>
        </>
    );
};

export default LocationDetails;
